/* eslint-disable */
import React from 'react';
import BackRoundButton from '../../../framework/forms/helpercomponents/buttons/BackRoundButton';
import AddRoundButton from '../../../framework/forms/helpercomponents/buttons/AddRoundButton';
import MobileGridCard from './MobileGridCard';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../../framework/forms/helpercomponents/Loader';
import { LocalDateTimeColumn } from '../../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { ConfirmDeleteAlert } from '../../../ConfirmAlert';
import { useTranslation } from '../../../locale/useTranslation';
import { DropDownList } from '@progress/kendo-react-dropdowns';

const DigitalSignMobileAdminCompanyCollection = (props) => {

    const { isLoading = false, gridData = [], showTitle = true, showAdd = true, showBack = true, onEnterEdit, myTitle, handleDelete, onSearch, sortByCompanies, selectSortByCompany, setSelectSortByCompany, onChangeSortByCompany } = props;

    const navigate = useNavigate();
    const lang = useTranslation();

    const handleItemClick = (data) => {
        return navigate(`/home/digitalSignDashboard?companyId=${data._id}`);
    };

    const onChange = (e) => {
        setSelectSortByCompany(e.target.value);
        onChangeSortByCompany(e.target.value);
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            {showTitle && (
                <div className="d-flex ml-1" style={{ alignItems: "center", flexWrap: "wrap", marginBottom: "10px" }}>
                    <i className="fa fa-table" style={{ fontSize: "large", color: "GrayText", marginRight: "5px" }}></i>
                    <span style={{ fontSize: "large", flex: "1", wordBreak: "break-word" }}>{myTitle}</span>
                </div>
            )}
            <div className="flex-container mt-2 mb-1">
                <div className='martb mar'>
                    {showBack && <BackRoundButton onClick={() => navigate(-1)} />}
                    {showAdd && <AddRoundButton onClick={onEnterEdit} />}
                </div>
                <div className='flex-container-reverse flex-item-auto'>
                    <div className="input-group input-group w-300 martb">
                        <input
                            type="text"
                            className="form-control shadow-inset-2 pt-0 pb-0"
                            id="searchInput"
                            placeholder={lang.search_button_text}
                            onChange={onSearch}
                        />
                        <button id="search" style={{ border: "0px", backgroundColor: "white", height: "38px" }}>
                            <div className="input-group-append">
                                <span className="input-group-text">
                                    <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                </span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>

            <div className=' mb-3'>
                <label>{lang.sort_by_label}</label>
                <DropDownList
                    style={{ backgroundColor: "white" }}
                    data={sortByCompanies}
                    name="sortBy"
                    textField="Description"
                    dataItemKey="_id"
                    value={selectSortByCompany}
                    onChange={onChange}
                />
            </div>
            <div className='mb-5' style={{ flex: 1, overflowY: "auto" }}>
                {isLoading ? (
                    <Loader />
                ) : gridData.length === 0 ? (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "65vh",
                            fontWeight: "500",
                            color: "grey",
                        }}
                    >
                        Add Company
                    </div>
                ) : (
                    gridData.map((item, index) => {
                            const whatsAppPhone = item?.SignUpData?.PhoneNo && item?.SignUpData?.PhoneNo.length >= 10 ? item.SignUpData.PhoneNo.slice(-10) : item?.SignUpData?.PhoneNo ?? "";
                            const contextMenuItem = [
                                {
                                    label: "Edit",
                                    command: (e) => {
                                        e.originalEvent.stopPropagation();
                                        onEnterEdit(item);
                                    },
                                    icon: "pi pi-pencil",
                                },
                                {
                                    label: "Delete",
                                    command: (e) => {
                                        e.originalEvent.stopPropagation();
                                        ConfirmDeleteAlert(() => handleDelete(item), () => { });
                                    },
                                    icon: "pi pi-trash",
                                },
                            ];
                            let phoneNo = item?.SignUpData?.PhoneNo ? item?.SignUpData?.PhoneNo  : ""
                            return (
                                <MobileGridCard
                                    key={index}
                                    title={item?.Name}
                                    imageUrl={
                                        item?.LogoUrl ??
                                        "https://i.postimg.cc/j5PsF5jZ/defaultmovie.png"
                                    }
                                    description={"Phone: " + phoneNo}
                                    contextMenuItem={contextMenuItem}
                                    topRight={
                                        <i
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                window.open(
                                                    `https://api.whatsapp.com/send?phone=${whatsAppPhone}&text=Hello ${item?.Name}`,
                                                    "_blank"
                                                );
                                            }}
                                            className="fa fa-whatsapp cursor-pointer"
                                            style={{ fontSize: "20px", color: "green" }}
                                        ></i>
                                    }
                                    label1={"Screen - Total:" + (item?.ScreenDetails?.total ?? 0) + ", " + "Online:" + (item?.ScreenDetails?.online ?? 0) + ", " + "Offline:" + (item?.ScreenDetails?.offline ?? 0)}
                                    label2={<LocalDateTimeColumn field="addOn" dataItem={item} />}
                                    bottomRight={"Plan: " + item?.plansCount + ", " + "User: " + item?.usersCount}
                                    showContextMenu={true}
                                    handleItemClick={handleItemClick}
                                    height="120px"
                                    data={item}
                                />
                            );
                        })
                )}
            </div>
        </div>
    )
}

export default DigitalSignMobileAdminCompanyCollection;
